module.exports = __webpack_public_path__ + "assets/img/Logo-Posadas.18c2b8ab.png";